// @flow

import React, { Component } from 'react';
import './notFound.css';

class NotFound extends Component {

  render() {
    return (
      <div className="not-found">
        <h2>ERROR 404!</h2>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/common/notFound/notFound.js